import { EventTypes } from '../types';
import { buildBaseEvent, buildClickEvent, buildHoverEvent } from './builders';

const { notification, encourageSellerReply } = EventTypes;

export const BigQueryEvents = {
    [notification.clicked]: buildClickEvent('clicked_on_notification'),
    [notification.markedAsRead]: buildClickEvent('marked_notification_as_read'),
    [notification.markedAsUnread]: buildClickEvent('marked_notification_as_unread'),
    [encourageSellerReply.hovered]: buildHoverEvent('encourage_seller_reply.hovered'),
    [encourageSellerReply.closed]: buildClickEvent('encourage_seller_reply.closed'),
    [encourageSellerReply.minimized]: buildClickEvent('encourage_seller_reply.minimized'),
    [encourageSellerReply.clickedOnBuyerName]: buildClickEvent('encourage_seller_reply.clicked_on_buyer_name'),
    [encourageSellerReply.clickedOnBubble]: buildClickEvent('encourage_seller_reply.clicked_on_bubble'),
    [encourageSellerReply.eligibleForExperience]: buildBaseEvent('encourage_seller_reply.eligible_for_experience'),
};
